import '.p{display:inline-flex;}.ssr-plugin'
import '.ee{gap:0.44rem;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.e{text-align:center;}.ssr-plugin'
import '.ef{padding-inline:1rem;}.ssr-plugin'
import '.eg{border-radius:2rem;}.ssr-plugin'
import '.eh{backdrop-filter:blur(2px);}.ssr-plugin'
import '.cd{user-select:none;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { Text } from '../typography/Text.js'
import { ReactNode } from 'react'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export type TagProps = {
  variant: Variant
  size?: Size
  label: string
  iconLeft?: IconDefinition
  iconRight?: IconDefinition
  style?: React.CSSProperties
  onClick?: () => void
}

export type Variant =
  | 'transparent'
  | 'pink'
  | 'yellow'
  | 'red'
  | 'blueMuted'
  | 'green'
  | 'gray'
type Size = 'large' | 'small'

const variantStyle: Record<Variant, Style> = {
  transparent: {
    background: 'transparent',
    color: 'var(--primary-blue)',
    border: '1px solid var(--primary-blue)',
  },
  pink: {
    background: 'var(--fine-pink)',
    color: 'var(--primary-blue)',
    border: '1px solid var(--fine-pink)',
  },
  yellow: {
    background: 'var(--sunlit-yellow)',
    color: 'var(--primary-blue)',
    border: '1px solid var(--sunlit-yellow)',
  },
  red: {
    background: 'var(--primary-red)',
    color: 'var(--shades-white)',
    border: '1px solid var(--primary-red)',
  },
  blueMuted: {
    background: 'var(--shades-blue-50)',
    color: 'var(--primary-blue)',
    border: 'var(--blue-border)',
  },
  green: {
    background: 'var(--semantic-green)',
    color: 'var(--primary-blue)',
    border: '1px solid var(--semantic-green)',
  },
  gray: {
    background: 'var(--shades-steady-stone)',
    color: 'var(--primary-blue)',
    border: '1px solid var(--shades-steady-stone)',
  },
}

const sizeStyle: Record<Size, Style> = {
  large: {
    paddingBlock: '0.5rem',
  },
  small: {
    paddingBlock: '0.25rem',
  },
}

const iconVariantStyle: Record<Variant, Style> = {
  transparent: {
    color: 'var(--primary-blue)',
  },
  pink: {
    color: 'var(--primary-blue)',
  },
  yellow: {
    color: 'var(--primary-blue)',
  },
  red: {
    color: 'var(--shades-white)',
  },
  blueMuted: {
    color: 'var(--primary-blue)',
  },
  green: {
    color: 'var(--primary-blue)',
  },
  gray: {
    color: 'var(--primary-blue)',
  },
}

const iconSizeStyle: Record<Size, Style> = {
  large: {
    fontSize: '0.9375rem',
  },
  small: {
    fontSize: '0.75rem',
  },
}

const sizeRender: Record<Size, (style: Style, label: string) => ReactNode> = {
  large: (style, label) => <Text.Medium style={style}>{label}</Text.Medium>,
  small: (style, label) => <Text.Small style={style}>{label}</Text.Small>,
}

export const Tag = ({
  variant,
  size = 'large',
  label,
  iconLeft,
  iconRight,
  style,
  onClick,
}: TagProps) => {
  return (
    <styled.div className="p ee g c e ef eg eh cd"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        ...style,
        ...sizeStyle[size],
        ...variantStyle[variant],
      }}
    >
      {iconLeft && (
        <FontAwesomeIcon
          key="icon"
          icon={iconLeft}
          style={{ ...iconSizeStyle[size], ...iconVariantStyle[variant] }}
        />
      )}
      {sizeRender[size]({ color: variantStyle[variant].color }, label)}
      {iconRight && (
        <FontAwesomeIcon
          key="icon"
          icon={iconRight}
          style={{ ...iconSizeStyle[size], ...iconVariantStyle[variant] }}
        />
      )}
    </styled.div>
  )
}
